import * as React from "react";
import {
  Icon,
  ILabelStyles,
  ILinkStyles,
  IStackStyles,
  mergeStyles,
  mergeStyleSets,
  registerIcons,
  Stack,
} from "@fluentui/react";
import { InfoBlock, InfoBlockLayout, InfoBlockProps } from "../InfoBlock/InfoBlock";
import { CircleMultiplySolid } from "../Svg/icons";
import { FormInputGroupLayout } from "./Form";

export const stackItemStyles: IStackStyles = { root: { paddingBottom: "15px" } };

export const baseLabelStyles: ILabelStyles = {
  root: {
    minHeight: "17px",
    marginTop: "3px",
    marginBottom: "4px",
    padding: 0,
    fontWeight: "400",
    fontSize: "13px",
  },
};

export const labelStyles: ILabelStyles = mergeStyleSets(
  baseLabelStyles,
  {
    maxWidth: "200px",
    width: "100%",
    minWidth: "200px",
  },
);

export const labelStylesSubField = mergeStyleSets(
  baseLabelStyles,
  { root: { minWidth: "202px", paddingLeft: "5px" } },
);

const subFieldWidth = 45;
const subFieldHorizontalMargin = 3;

export const subFieldBorder = {
  display: "block",
  borderLeft: "1px solid #a9a9a9",
  borderBottom: "1px solid #a9a9a9",
  width: `${subFieldWidth}px`,
  height: "25px",
  marginTop: "-15px",
  marginLeft: `${subFieldHorizontalMargin}px`,
};

export const iconClass = mergeStyles({
  fontSize: 13,
  marginLeft: "5px",
  verticalAlign: "middle",
});

export const labelStylesWithToolTip: ILabelStyles = baseLabelStyles;

export const labelStylesSubFieldWithTooltip = mergeStyleSets(
  labelStylesWithToolTip,
  labelStylesSubField,
);

export const stackItemStylesWithToolTip: IStackStyles = { root: { minWidth: "250px" } };

export const linkStylesWide: ILinkStyles = {
  root: {
    paddingBottom: "10px",
    paddingLeft: "250px",
  },
};

export const linkStylesCompact: ILinkStyles = {
  root: {
    paddingBottom: "10px",
    maxWidth: "fit-content",
  },
};

const errorMessageStylesWide = {
  maxHeight: "30px",
  paddingLeft: "250px",
};

const errorMessageStylesCompact = { maxHeight: "30px" };

const infoBlockCompactStyles: IStackStyles = {
  root: {
    maxWidth: "calc(100% - 250px)",
    marginLeft: "250px",
    marginBottom: "15px",
  },
};

const infoBlockStretchedStyles: IStackStyles = { root: { marginBottom: "15px" } };

registerIcons({ icons: { "error-svg": CircleMultiplySolid } });

export const renderStatusBar = (
  statusInfo: InfoBlockProps,
  layout: FormInputGroupLayout,
): JSX.Element => (
  <InfoBlock
    {...statusInfo}
    customInfoStyle={
      layout === FormInputGroupLayout.WIDE
        ? statusInfo.infoLayout === InfoBlockLayout.Compact
          ? infoBlockCompactStyles
          : infoBlockStretchedStyles
        : infoBlockStretchedStyles
    }
  />
);

export const renderErrorMessages = (
  errorMessages: string[],
  layout: FormInputGroupLayout,
  testId?: string,
): JSX.Element => {
  const errorStyles = layout === FormInputGroupLayout.COMPACT
    ? errorMessageStylesCompact
    : errorMessageStylesWide;

  const errors = errorMessages.map(error => (
    <Stack horizontal key={error} data-test-id={testId}>
      <span style={errorStyles}>
        <Icon iconName="error-svg" />
      </span>
      <span
        style={{
          display: "block",
          marginLeft: "10px",
          fontSize: "13px",
          color: "#a4262c",
        }}
      >
        {error}
      </span>
    </Stack>
  ));
  return (
    <Stack style={{ paddingBottom: "15px", marginTop: "-2px" }}>{errors}</Stack>
  );
};

export interface SimpleBuilderInternalProps {
  /**
   * label is required if field needs to be mapped with preflight
   */
  label?: string;
}
